import React from 'react';
import './Modal_2.css';

import x from "../../../../asset/x.svg";
import backgroundImage from "../../../../asset/video_select_background_image.png";
import click_or_drag from "../../../../asset/drag_or_click.svg";

const Modal2 = ({ onClose }) => {
  return (
    <div className="drawing-modal-container_2" onClick={onClose}>
      <div className="drawing-modal-upper_2">
          <img
              src={x}
              alt={"x"}
              onClick={onClose}
              className="drawing-modal-upper-x_2"
              style={{
                  height: "20px",
                  float: "left",
                  margin: "2%"
              }}
          />
      </div>
      <div className="drawing-modal-lower_2" onClick={(e) => e.stopPropagation()}>
        <img
            src={backgroundImage}
            alt={"background_image"}
            style={{
                width: "15vw",
                height: "auto",
                paddingTop: "1%",
                opacity: "40%"
            }}
        />
        <img
            src={click_or_drag}
            alt={"click-the-image"}
            style={{
                width: "12vw",
                height: "auto",
                position: "absolute",
                left: "10%",
                top: "6%"
            }}
        />
      </div>
      <div className="drawing-modal-bottom_2">
      </div>
    </div>
  );
};

export default Modal2;